import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5915ee00"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-content loader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "field"
}
const _hoisted_4 = { class: "control is-expanded" }
const _hoisted_5 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "has-text-right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button has-text" }, " manage ", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrientationPanel = _resolveComponent("OrientationPanel")!
  const _component_Classifications = _resolveComponent("Classifications")!
  const _component_MLClassSelect = _resolveComponent("MLClassSelect")!
  const _component_DropdownContent = _resolveComponent("DropdownContent")!
  const _component_Transcriptions = _resolveComponent("Transcriptions")!
  const _component_TranscriptionsModal = _resolveComponent("TranscriptionsModal")!
  const _component_TranscriptionCreationForm = _resolveComponent("TranscriptionCreationForm")!
  const _component_ElementMetadata = _resolveComponent("ElementMetadata")!
  const _component_ElementDatasets = _resolveComponent("ElementDatasets")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.element || !_ctx.corpusId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.elementType?.folder)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_OrientationPanel, { "element-id": _ctx.elementId }, null, 8, ["element-id"]),
                _hoisted_2
              ], 64))
            : _createCommentVNode("", true),
          ((_ctx.canWriteElement(_ctx.elementId) && _ctx.hasMLClasses[_ctx.corpusId]) || _ctx.classifications.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_DropdownContent, {
                  id: "classifications",
                  title: "Classifications"
                }, {
                  default: _withCtx(() => [
                    (_ctx.classifications)
                      ? (_openBlock(), _createBlock(_component_Classifications, {
                          key: 0,
                          element: _ctx.element
                        }, null, 8, ["element"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("form", {
                      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createClassification && _ctx.createClassification(...args)), ["prevent"]))
                    }, [
                      (_ctx.canWriteElement(_ctx.elementId) && _ctx.hasMLClasses)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("p", _hoisted_4, [
                              _createVNode(_component_MLClassSelect, {
                                ref: "newClassificationSelect",
                                modelValue: _ctx.selectedNewClassification,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedNewClassification) = $event)),
                                "is-valid": _ctx.validClassification,
                                "onUpdate:is-valid": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.validClassification) = $event)),
                                placeholder: "Add a classification",
                                "exclude-manual": "",
                                "auto-select": "",
                                classifications: _ctx.classifications,
                                "corpus-id": _ctx.corpusId
                              }, null, 8, ["modelValue", "is-valid", "classifications", "corpus-id"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.manualClassificationExists)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "A manual classification for this ML class already exists."))
                        : _createCommentVNode("", true)
                    ], 32)
                  ]),
                  _: 1
                }),
                _hoisted_6
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_DropdownContent, {
            id: "transcriptions",
            title: "Transcriptions"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Transcriptions, { element: _ctx.element }, null, 8, ["element"]),
              (_ctx.canWriteElement(_ctx.elementId))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("a", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.transcriptionModal = true))
                      }, _hoisted_9)
                    ]),
                    (_ctx.transcriptionModal)
                      ? (_openBlock(), _createBlock(_component_TranscriptionsModal, {
                          key: 0,
                          modal: _ctx.transcriptionModal,
                          "onUpdate:modal": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.transcriptionModal) = $event)),
                          element: _ctx.element
                        }, null, 8, ["modal", "element"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _hoisted_10,
          (_ctx.canWriteElement(_ctx.elementId))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_DropdownContent, {
                  id: "new-transcription",
                  title: "New transcription"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TranscriptionCreationForm, { element: _ctx.element }, null, 8, ["element"])
                  ]),
                  _: 1
                }),
                _hoisted_11
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_DropdownContent, {
            id: "metadata",
            title: "Metadata"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElementMetadata, {
                "corpus-id": _ctx.corpusId,
                "element-id": _ctx.element.id
              }, null, 8, ["corpus-id", "element-id"])
            ]),
            _: 1
          }),
          _hoisted_12,
          _createVNode(_component_DropdownContent, {
            id: "datasets",
            title: "Datasets"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElementDatasets, {
                "corpus-id": _ctx.corpusId,
                element: _ctx.element
              }, null, 8, ["corpus-id", "element"])
            ]),
            _: 1
          })
        ], 64))
  ]))
}